module.exports = __webpack_public_path__ + "static/media/markets.883a6a76.png";